import { Button } from "../../ui/ot";
import { Row, Col, Input, Form } from "../../ui/ot";
import { useState } from "react";
import AdvancedSearchForm from "./advanced_search_form"
import { useSearchParams, useNavigate } from "react-router-dom";

const SearchBar = ({
    propsNavigateSearchPath = '',
    defaultAdvancedSearch = false,
    backgroundColor = false,
    // onSearch = () => { },
}) => {
    const navigate = useNavigate();
    const [searchKeyword, setSearchKeyword] = useState("");
    const [author, setAuthor] = useState(""); // 進階欄位：作者
    const [isbn, setIsbn] = useState("");     // 進階欄位：ISBN
    const [error, setError] = useState("");
    const [advancedSearch, setAdvancedSearch] = useState(defaultAdvancedSearch);
    const [advanced_search_form] = Form.useForm(); //form 
    const [searchParams, setSearchParams] = useSearchParams();
    const [tableSearchParams, setTableSearchParams] = useState({
        branchcode_arr: [],
        ...Object.fromEntries(searchParams.entries()),
    });
    const handleSearchClick = (e) => {
        e.preventDefault();
        if (!searchKeyword.trim()) {
            setError("請輸入關鍵字");
            return;
        }
        setError("");

        const params = {
            keyword: searchKeyword,
            author: author,
            isbn: isbn,
            advanced: advancedSearch,
        };

        // if (onSearch) {
        //     // 如果外部有傳 onSearch function，就用外部的！
        //     onSearch(params);
        // } else {
        // 如果沒有傳，就自己 navigate
        const searchParams = new URLSearchParams({ 
            search:searchKeyword,
            // keyword: searchKeyword 
        });
        if (advancedSearch) {
            searchParams.append('mode', 'advanced');
            if (author.trim()) searchParams.append('author', author);
            if (isbn.trim()) searchParams.append('isbn', isbn);
        }
        navigate(`${propsNavigateSearchPath}/online_public_catalog_query_construction/bib_search_function?${searchParams.toString()}`);
        // }
    };
    const handleToggleSearchMode = () => {
        setAdvancedSearch((prev) => !prev);
    };

    return (
        <form className="w-full p-6 bg-gray-50 rounded-lg shadow-md" onSubmit={handleSearchClick}>
            <div className="flex w-full items-center gap-3">
                {/* 搜尋欄位 */}
                <div className="flex flex-col flex-1">
                    <Input
                        placeholder="搜尋館藏、作者、ISBN..."
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                        className={`pl-4 pr-4 py-2 text-base rounded-md border ${error ? "border-red-500" : "border-gray-300"} focus:border-blue-500 w-full shadow-sm transition`}
                    />
                </div>

                {/* 查詢按鈕 */}
                <div className="flex-shrink-0 flex flex-col gap-2">
                    <Button
                        className="h-10 px-4 rounded-md bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white text-sm font-semibold shadow-md transition-transform transform hover:scale-105 whitespace-nowrap"
                        onClick={handleSearchClick}
                        type="submit"
                    >
                        查詢
                    </Button>

                    {/* 進階/一般切換按鈕 */}
                </div>
                {defaultAdvancedSearch &&
                    <div className="flex-shrink-0 flex flex-col gap-2">
                        <Button
                            type="button"
                            onClick={handleToggleSearchMode}
                            className="h-8 px-3 rounded-md bg-gray-300 hover:bg-gray-400 text-gray-700 text-xs font-medium shadow-sm whitespace-nowrap transition"
                        >
                            {advancedSearch ? "一般查詢" : "進階查詢"}
                        </Button>
                    </div>
                }
            </div>

            {/* 錯誤訊息 */}
            {error && (
                <div className="h-5 mt-1 ml-2 text-xs text-red-500">
                    {error}
                </div>
            )}

            {/* 進階搜尋區塊 */}
            {advancedSearch && (
                <div className="mt-6">
                    <Row justify="center">
                        <Col xxl={20} xl={20} lg={20} md={22} sm={24} xs={24}>
                            <AdvancedSearchForm
                                propsForm={advanced_search_form}
                                onFormFinish={(formValue) => {
                                    let { search } = formValue;
                                    let values = {};
                                    search?.forEach((element, index) => {
                                        if (index === 0) {
                                            values[`field`] = element?.field;
                                            values[`keyword`] = element?.keyword;
                                        } else {
                                            values[`field${index + 1}`] = element?.field;
                                            values[`keyword${index + 1}`] = element?.keyword;
                                            values[`operator${index + 1}`] = element?.operator;
                                        }
                                    });
                                    setTableSearchParams((pre) => ({
                                        ...values,
                                        branchcode_arr: pre?.branchcode_arr,
                                    }));
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            )}
        </form>

    );
};

export default SearchBar;
